import { render, staticRenderFns } from "./AccountAccess.vue?vue&type=template&id=4148d9fc&"
import script from "./AccountAccess.vue?vue&type=script&lang=ts&"
export * from "./AccountAccess.vue?vue&type=script&lang=ts&"
import style0 from "./AccountAccess.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports